import de from './translations/de';
import en from './translations/en';

export default {
  de,
  en
};
